import { RootState } from '@app/store/types';

/**
 * * @todo: 사용자 기능 권한 제어는 워크스페이스 역할 내 권한으로 확인하면 됩니다.
 * * (user/authority는 workpsace/authority로 대체되며) workpsace/authority의 permission은
 * * 워크스페이스 자체에 대한 기능/권한 제어 이므로, 기능제어 보다는 워크스페이스가 사용중인 요금제가 제공하는 기능을 표현하는 것 외에는 드물게 사용될겁니다
 */
import { ExportInputValuesState } from './state';
// import { getHasExportInputValuesPermission } from '@app/store/user/authority/selectors';

export const getExportValuesState = (state: RootState): ExportInputValuesState =>
  state.exportValues;

export const getJobId = (state: RootState) => getExportValuesState(state).jobId;
